





































































import Vue, { PropType } from 'vue'
import XCard from '@/components/atoms/Card/XCard.vue'
import XFormLabel from '@/components/atoms/FormLabel/XFormLabel.vue'
import { AgentSalesDestination } from '@/types/generated/graphql'
import XButton from '@/components/atoms/Button/XButton.vue'
export default Vue.extend({
  name: 'AgentDestinationItem',
  components: { XFormLabel, XCard, XButton },
  props: {
    destination: {
      type: Object as PropType<AgentSalesDestination>,
      required: true,
    },
  },
  methods: {
    onClickSelect(destination: AgentSalesDestination) {
      this.$emit('select:destination', destination)
    },
  },
})
